module.exports = __webpack_public_path__ + "img/d9beb51.png";